module.exports = __webpack_public_path__ + "img/O.b68f4ba5.svg";